import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import AddSizeCategory from '@features/measurement/components/AddSizeCategory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { changeSelectedSizeCategoryId, fetchAllSizeCategories } from '@store/actions/MeasurementAction';
import { getPomAndSize, useMeasurement } from '@store/reducers';

import { getPrimaryUserType, getShortName, isAdmin } from '@utils/Util';

const BrandWiseSizeCategoryDropdown = ({ disabled, onAddSuccess }) => {
	const designToolStore = useSelector((store) => store.designToolStore);
	const [nitexStandardSize, setNitexStandardSize] = useState([]);
	const [selectedSizeId, setSelectedSizeId] = useState(null);
	const [openAddModal, setOpenAddModal] = useState(false);
	const [brandWiseSize, setBrandWiseSize] = useState([]);
	const pomAndSizeList = useSelector(getPomAndSize);
	const measurement = useMeasurement();
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		(async () => {
			try {
				dispatch(openLoader());
				await dispatch(fetchAllSizeCategories(`?productId=${id}`));
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, []);

	useEffect(() => {
		let nitexSizes = [];
		let brandSizes = [];

		measurement.sizeCategories.forEach((item) => {
			if (item?.brandId) {
				brandSizes.push(item);
			} else {
				nitexSizes.push(item);
			}
		});
		setNitexStandardSize(nitexSizes);
		setBrandWiseSize(brandSizes);
	}, [measurement?.sizeCategories]);

	const changeSizeCategory = (id) => {
		dispatch(changeSelectedSizeCategoryId(id));
	};

	const renderBrandWiseSize = () => {
		return brandWiseSize?.map((item, index) => {
			return (
				<li key={`brand_${index}_wise_size`} className="d-flex justify-content-between">
					<span onClick={() => changeSizeCategory(item.id)}>{item.name}</span>
					<Tooltip title={item.range}>
						<span onClick={() => changeSizeCategory(item.id)}>
							{getShortName(item.range, 17)}
						</span>
					</Tooltip>
					{isAdmin() && (
						<span
							className="cursor-pointer"
							onClick={() => {
								setSelectedSizeId(item.id);
								setOpenAddModal(true);
							}}
						>
							Edit
						</span>
					)}
				</li>
			);
		});
	};

	const renderNitexStandardSize = () => {
		return nitexStandardSize?.map((item, index) => {
			return (
				<li
					key={`brand_${index}_wise_size`}
					className="d-flex justify-content-between"
					onClick={() => changeSizeCategory(item.id)}
				>
					<span>{item.name}</span>
					<span>{item.range}</span>
				</li>
			);
		});
	};

	const renderEmptyState = (sizeList) => {
		if (sizeList.length === 0) {
			return (
				<div className="empty px-3 py-2">
					<span className="regular-14 gray_dark_03">No size category added</span>
				</div>
			);
		}
	};

	return (
		<>
			<div className="brand-wise-size-category-dropdown">
				<button
					disabled={disabled}
					className="button text size32 d-flex justify-content-between align-items-center"
					type="button"
					id="downloadType"
					data-toggle="dropdown"
					aria-expanded="false"
				>
					{pomAndSizeList?.sizeCategory?.name || 'Size category'}
					<img
						src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`}
						alt="download"
						className="ml-2"
					/>
				</button>
				<div
					className="dropdown-menu dropdown-menu-right shadow-lg"
					role="menu"
					aria-labelledby="downloadType"
				>
					<div className="other-categories">
						<div className="border-bottom-solid px-3 py-2">
							<button className="button text-only w-100 d-flex justify-content-between align-items-center">
								<span className="mr-1 regular-12 weight-500">
									{designToolStore?.brandName?.toUpperCase()} SIZE STANDARD
								</span>
								{['ADMIN'].includes(getPrimaryUserType()) && (
									<img
										src={`${process.env.PUBLIC_URL}/icons/add-round.svg`}
										alt="add"
										onClick={() => setOpenAddModal(true)}
									/>
								)}
							</button>
						</div>
						{renderEmptyState(brandWiseSize)}
						<ul className="category-list scroll-y-label">{renderBrandWiseSize()}</ul>
					</div>
					<div className="nitex-standard mt-2">
						<h3 className="regular-12 weight-500 px-3 py-2 border-bottom-solid">
							NITEX SIZE STANDARD
						</h3>
						{renderEmptyState(nitexStandardSize)}
						<ul className="category-list scroll-y-label">{renderNitexStandardSize()}</ul>
					</div>
				</div>
			</div>
			{openAddModal && (
				<AddSizeCategory
					selectedId={selectedSizeId}
					onAddSuccess={onAddSuccess}
					onClose={() => {
						setOpenAddModal(false);
						setSelectedSizeId(null);
					}}
				/>
			)}
		</>
	);
};

export default BrandWiseSizeCategoryDropdown;
